<template>
  <div class="pt20">
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>产品介绍</p>
      <div class="tool_company design_box banner-product">
        <div class="product_swiper"
             :style="{'background':'url('+(property.pic[0]?property.pic[0]:'/static/img/userDefult.png')+') repeat scroll center center / cover'}">
        </div>
        <p class="product_swiper_crole"><span></span><span></span><span></span></p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    }
  };
</script>



